import PropTypes from 'prop-types'
import styles from './Pill.module.css'

const COLORS = ['default', 'rojo', 'verde', 'amarillo', 'celeste']
const SIZES = ['sm', 'md', 'lg']

export function Pill({
  color = 'default',
  size = 'md',
  iconLeft,
  iconRight,
  disabled = false,
  onClick,
  className = '',
  children,
}) {
  const classes = [
    styles.pill,
    styles[color],
    styles[size],
    className,
  ].filter(Boolean).join(' ')

  return (
    <button
      type="button"
      className={classes}
      disabled={disabled}
      onClick={onClick}
    >
      {iconLeft}
      {children}
      {iconRight}
    </button>
  )
}

Pill.propTypes = {
  color: PropTypes.oneOf(COLORS),
  size: PropTypes.oneOf(SIZES),
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}
